import styled from "styled-components";

export const ActionBar = styled.div`
  background-color: var(--orange-300);
  display: flex;
  padding: 24px;
  border-radius: 64px;
  width: 1200px;
  position: relative;
  gap: 48px;
  display: none;
  justify-content: center;
  z-index: 10;
  margin: 0 auto;
  margin-top: -44px;
  margin-bottom: -60px;
  z-index: 10;

  @media (min-width: 1440px) {
    display: flex;
  }


  h3{
    font-size: 20px;
    font-style: normal;
    font-weight: 550;
    line-height: 28px; 
    letter-spacing: 1px;
    color: var(--orange-600);
    text-align: left;
    width: 727px;
  }
`
export const ActionBtn = styled.button`
  background-color: var(--orange-500);
  border: 1px solid var(--orange-500);
`